// src/store/index.js
import { createPinia } from 'pinia'

// Create and export the root pinia instance
const pinia = createPinia()

export default pinia
